import { Flex, ModalPrimitive } from "@wayflyer/flyui";
import { styled } from "styled-components";

export const DialogFooter = styled(Flex)`
  align-items: center;
  justify-content: center;
`;

export const DialogContent = styled(Flex)`
  text-align: center;
`;

export const StyledModalPrimitive = styled(ModalPrimitive)`
  border: none;
  overflow: hidden;
  max-width: 438px;

  @media (max-width: 640px) {
    width: calc(100vw - 24px);
  }
`;
